var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-table-cell-status",class:{
        _positive: _vm.status === 'accepted',
        _negative: _vm.status === 'rejected',
        _neutral: _vm.status === 'delayed',
        _pending: _vm.status === 'pending',
    }},[_c('div',{staticClass:"ui-table-cell-status__indicator"}),_c('div',{staticClass:"ui-table-cell-status__title",domProps:{"textContent":_vm._s(_vm.statusText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }